<script setup>
    import { useChannelsStore } from '@/stores/channels'
    import InputFormHorizontal from '@/components/UI/Form/InputFormHorizontal'
    import FeedbackAlert from '@/components/utils/FeedbackAlert'
    import AlertPrice from '@/views/dash/channels/Pages/AlertPrice'
    import FeedbackSimpleAlert from '@/components/utils/FeedbackSimpleAlert'

    const store = useChannelsStore()

    store.channel.type = store.channel.type || 'telegram'
    store.channel.server_type = store.channel.server_type || 'telegram'
</script>

<template>
    <template v-if="store.formStep === 2">
        <div class="space-y-4">
            <FeedbackAlert
                type="info"
                title="Atenção!"
                content="Sugerimos que copie o token gerado do Bot Father e cole abaixo, para garantir o funcionamento!"
            />
            
            <InputFormHorizontal
                v-model="store.channel.name"
                :init-value="store.channel.name"
                :block-edit="store.loading"
                label="Nome do canal"
                placeholder="Como você irá identificar o canal pelo sistema?"
                rules="required"
                vertical
            />
            
            <InputFormHorizontal
                v-model="store.channel.user"
                :init-value="store.channel.user"
                label-left=" @ "
                :block-edit="store.loading"
                label="Qual o usuário do BOT criado no Telegram?"
                placeholder="Insira o usuário do bot... exemplo: @telegram_bot"
                rules="required"
                vertical
            />
            
            <InputFormHorizontal
                v-model="store.channel.api_token"
                :init-value="store.channel.api_token"
                :block-edit="store.loading"
                label="Token copiado do Bot Father"
                placeholder="Cole o token gerado com Telegram"
                rules="required"
                vertical
            />
            
            <FeedbackSimpleAlert
                v-if="store.channel?.id"
                class="w-full block text-center"
                content="<b>Cuidado: alterando o token para outro incorreto, o Bot deixará de funcionar!</b>"
            />
            
            <AlertPrice />
        </div>
    </template>
    
    <div
        v-else-if="store.formStep === 1"
        class="flex-1 relative overflow-y-scroll fade_start_end pt-5"
    >
        <div class="h-96 dark:text-gray-300">
            <p class="text-sm">
                Com o Telegram você pode utilizar bot's, para auxiliar e automatizar tarefas, com o intuito de
                tornar o processo de atendimento e vendas ainda mais prático, ágil e fluido!
            </p>
            <h3 class="text-lg block mt-3 mb-1 font-medium">
                Vantagens de se ter um bot
            </h3>
            <p class="text-sm">
                A principal diferença do Telegram para o Whatsapp que ele não exige um número de telefone para
                configurar
                uma conta, deixando o seu uso ainda mais simples. O bot funciona independente do celular, ou seja, você
                NUNCA terá problemas de desconexão, quedas repentinas ou outros. O bot irá operar 7 dias por semana, 24
                horas constantes!
            </p>
            <h3 class="text-lg block mt-3 mb-1 font-medium">
                Criando seu primeiro bot
            </h3>
            <mark class="text-sm block bg-yellow-50 border border-amber-200 text-gray-600 p-2 rounded-md dark:bg-opacity-20 dark:border-opacity-30 dark:text-gray-300">
                O processo para criar um bot no Telegram é tão simples, que há um bot para lhe auxiliar no processo:
                BotFather
            </mark>
            <h3 class="block mt-3 mb-1 font-medium">
                1º - Localizando o criador de bot's
            </h3>
            <p class="text-sm">
                Com o app do Telegram já aberto, no topo pesquise por @BotFather. Vários usuários serão exibidos, se
                atente e selecione o que tiver o ícone de verificado. Após, toque no botão start que será exibido.
            </p>
            <img
                alt=""
                class="block mx-auto my-5"
                src="https://vmix.notion.site/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F3998ed7d-f4df-4289-9abf-2019c5d8e98e%2FScreen_Shot_2021-12-22_at_07.47.04.png?table=block&id=70106774-9aaa-4894-96dd-84f2dc36c103&spaceId=e030ce50-6527-4734-a5a4-8e6b318b01ab&width=280&userId=&cache=v2"
            >
            <h3 class="block mt-3 mb-1 font-medium">
                2º - Criando o bot
            </h3>
            <p class="text-sm">
                Uma lista com várias funcionalidades disponíveis no BotFather será exibida. Para criar o seu primeiro
                bot,
                envie ou toque no comando "/newbot" . Após, ele irá te pedir para enviar:
            </p>
            <ol class="ml-5 my-2 text-sm">
                <li>1. Insira um <b>NOME</b> o seu bot;</li>
                <li>2. O <b>USUÁRIO</b> do bot que obrigatoriamente deverá terminar com termo Bot ou _bot</li>
            </ol>
            <small class="italic text-sm">
                ** O nome do usuário do bot deverá ser único e, por isso, caso o que enviou já estiver em uso, o
                Telegram
                poderá lhe pedir para escolher um novo nome.
            </small>
            <img
                alt=""
                class="block mx-auto"
                src="https://vmix.notion.site/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F9206dbcd-2062-43b8-9727-a9f3da324b6c%2F5yranb.gif?table=block&id=818bfcb7-61c7-4cb7-bbd4-9e2ee80eadf3&spaceId=e030ce50-6527-4734-a5a4-8e6b318b01ab&userId=&cache=v2"
            >
            <h3 class="block mt-3 mb-1 font-medium">
                3º - Acessando o token
            </h3>
            <p class="text-sm">
                Por fim, finalizando as etapas acima de escolha de nome e usuário, o BotFather lhe apresentará o token
                de
                seu bot. Com ele, você conseguirá cadastrar o seu bot no Chat, na tela de canais, e já começar a
                utilizar!
            </p>
            <mark class="text-sm block bg-yellow-50 border border-amber-200 text-gray-600 p-2 mt-3 rounded-md dark:bg-opacity-20 dark:border-opacity-30 dark:text-gray-300">
                Toque no token e o Telegram irá copiá-lo para que você utilize em outros locais!
            </mark>
            <img
                alt=""
                class="block mx-auto"
                src="https://vmix.notion.site/image/https%3A%2F%2Fs3-us-west-2.amazonaws.com%2Fsecure.notion-static.com%2F25ec4e6b-6949-42df-b4d5-e25eee2137aa%2FScreen_Shot_2021-12-22_at_07.51.52.png?table=block&id=aaf03c1b-a4df-4f08-a582-79e26adede9f&spaceId=e030ce50-6527-4734-a5a4-8e6b318b01ab&width=2000&userId=&cache=v2"
            >
        </div>
    </div>
</template>